import { render, staticRenderFns } from "./ChartWrapper.vue?vue&type=template&id=160a4348&"
import script from "./ChartWrapper.vue?vue&type=script&lang=js&"
export * from "./ChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports